import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  closePushMessage: false,
};
const closePushMessageSlice = createSlice({
  name: "closePush",
  initialState,
  reducers: {
    updateClosePushMessage: (state, { payload }) => {
      state.closePushMessage = payload;
    },
  },
});

export const { updateClosePushMessage } = closePushMessageSlice.actions;
export default closePushMessageSlice.reducer;
